import { useContext } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import logo from "../images/10782979_19199385.jpg"

const Welcome=()=>{

    const {setLogin,setSignup,setPresentation}=useContext(ItemsContext)

    const handleClick1=()=>{
        setLogin(true)   
    }
    const handleClick2=()=>{
        setSignup(true)   
    }
    const handleClick3=()=>{
        setPresentation(true)   
    }

    return(
        <div className="welcome">
       
           
        
            
            <div className="inner">
        
                   <button id="tr"onClick={handleClick3}>TR</button>
            
                <h1>Welcome to <span>Task</span><span>Ranger</span></h1><br></br><br></br><br></br>
                <h3>Log in or sign in to continue</h3>
                <button onClick={handleClick1}>Log in</button>
                <button onClick={handleClick2}>Sign up</button>
            </div>
            <div>
                <img src={logo} alt="logo" />            
            </div>
           

        </div>
    )
}

export default Welcome